module.exports = __webpack_public_path__ + "img/database-03.242151eb.svg";